// components/GiftModal.tsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';

type GiftModalProps = {
  show: boolean;
  onClose: () => void;
};

const GiftModal: React.FC<GiftModalProps> = ({ show, onClose }) => {
  const [modalStep, setModalStep] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [fade, setFade] = useState(true);
  const { canvaAuthenticated,token } = useCanvaAuth();

  const env = canvaAuthenticated?.env;

  const handleFadeChange = (nextStep: number) => {
    setFade(false);
    setTimeout(() => {
      setModalStep(nextStep);
      setFade(true);
    }, 200);
  };

  const handleClaimGift = async () => {
    if (!token || !env?.claimGiftUrl) return;

    try {
      await fetch(env.claimGiftUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ giftId: canvaAuthenticated?.userProfile?.gift })
      });
      handleFadeChange(1);
    } catch (error) {
      // Handle error silently
    }
  };

  const handleSendFeedback = async () => {
    if (!token || !env?.feedbackUrl) return;

    try {
      await fetch(env.feedbackUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ feedback }),
      });
      handleFadeChange(2);
    } catch (error) {
      // Handle error silently
    }
  };

  return (
    <Modal show={show} onHide={onClose} contentClassName="gift-modal" centered backdrop="static">
      <div className={`transition-opacity ${fade ? 'opacity-100' : 'opacity-0'} transition duration-300`}>
        <Modal.Header>
          <Modal.Title>
            {modalStep === 0 ? '🎉 A Little Gift for You' :
             modalStep === 1 ? "🎧 Enjoy your extra time! ":
             '🙏 Thank You'}
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={onClose} />
        </Modal.Header>

        <Modal.Body>
          {modalStep === 0 && (
            <div className="text-center px-2">
			  <h5 className="mb-3">You've made it — thank you!</h5>
			  <p className="mb-2">We really appreciate you being here with us. As a small token of our thanks, we'd love to gift you some extra music time.</p>
			  <p className="mb-4">Click below to receive <strong>100 bonus seconds</strong> to use however you like 🎶</p>
			  <Button variant="primary" onClick={handleClaimGift}>
				🎁 Claim Your Gift
			  </Button>
			</div>
          )}

          {modalStep === 1 && (
            <>
              <div className="text-center px-2 mb-3">
				  <p className="mb-1">We’d love to hear from you.</p>
				  <p className="mb-3">Is there anything we can do to make AI music even better for you?</p>
				</div>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Your thoughts..."
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                </Form.Group>
                <div className="d-flex justify-content-between">
                  <Button variant="secondary" onClick={onClose}>Cancel</Button>
                  <Button variant="primary" onClick={handleSendFeedback}>Send</Button>
                </div>
              </Form>
            </>
          )}

          {modalStep === 2 && (
            <div className="text-center">
              <p>Thanks a lot! We really appreciate your thoughts.</p>
              <Button variant="primary" onClick={onClose}>Close</Button>
            </div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default GiftModal;
